// extracted by mini-css-extract-plugin
export default {"container":"FormBlockWithLogo_container__sTPxD","viewForm":"FormBlockWithLogo_viewForm__Lxmee"};